<template>
    <rkm-table
        :fields="fields"
        :items="data.model.telefones"
        hide-filters
    >
        <template v-slot:cell(actions)="{ index }">
            <rkm-button
                color="danger"
                title="Excluir"
                small
                @click.stop="remove(index)"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
export default {
    computed: {

        fields() {

            return [
                {
                    key: 'numero',
                    label: 'Número',
                    sortable: true
                },
                {
                    key: 'observacao',
                    label: 'Observação',
                    sortable: true
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    methods: {
        remove(index) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o telefone?',
                async () => this.data.model.telefones.splice(index, 1)
            )
        },
    },
    props: {
        data: { type: Object, required: true }
    },
}
</script>